function haversine_distance(mk1, mk2) {
  console.log(mk1);
  console.log(mk2);
    var R = 6371.0710;
    var rlat1 = mk1.lat * (Math.PI/180); // Convert degrees to radians
    var rlat2 = mk2.lat * (Math.PI/180); // Convert degrees to radians
    var difflat = rlat2-rlat1; // Radian difference (latitudes)
    var difflon = (mk2.lng-mk1.lng) * (Math.PI/180); // Radian difference (longitudes)

    var d = 2 * R * Math.asin(Math.sqrt(Math.sin(difflat/2)*Math.sin(difflat/2)+Math.cos(rlat1)*Math.cos(rlat2)*Math.sin(difflon/2)*Math.sin(difflon/2)));
    return d;
  }

// var distance = haversine_distance(mk1, mk2);
// console.log(distance);




// used to sort LOCATIONS components that are child or parent ids
  
  export const sortParentIdComponent = (dataSearch) =>{

  var geocoderLocation = [];
  console.log(`STEP 1`);
  var dataCopy = JSON.parse(JSON.stringify(dataSearch));

    var sortComponents = [];
    var sortLocations = [];
    var sortLocationsCopy = [];
    var userLocation = getUserPosition();
    var count = 0;

    var myLatlng1 = new window.google.maps.LatLng(45.512757, -73.459746);
    var mk1 =  new window.google.maps.Marker({
        position: myLatlng1,
        title:"Marker 1"
    });

    dataCopy.map(function (eachObject) {
        
        if(eachObject.action.type === 'locationLink'){
          
          console.log(`STEP 2`);

                // console.log("Distance in Kilometers: ", (distanceInMeters * 0.001).toFixed(2));  
                // TODO 1: assign to each the distance compared to the user
                // eachObject.order = (distanceInMeters * 0.001).toFixed(2);
                // console.log(eachObject);
                console.log(`STEP 3`);
                sortLocations.push(eachObject);
                console.log(`STEP 4`);
                sortLocations.sort((a, b) => (a.order > b.order) ? 1 : -1);

            // TODO 2: add into array the element
            console.log(`STEP 5`);
            console.log(sortLocations);
            
            // TODO 3: change order of sort in array and put them from 1
            // TODO 4: sort location array with new data
            
            // const test = [12.62, 2.62, 12.67];
            // test.sort( (a, b) => (a > b) ? 1 : -1);
            // console.log(test);
            
            // console.log(sortLocations);
            
          }else{
            console.log(`STEP 1.1`);
            sortComponents.push(eachObject)
            sortComponents.sort((a, b) => (a.order > b.order) ? 1 : -1);
          }
        })
        // console.log(dataCopy);
        // console.log(sortComponents.concat(sortLocations));
        console.log(`STEP 6`);
        console.log(sortLocations);
        
    return sortLocations.concat(sortComponents);
}

const successCallback = (position) => {
    console.log(position);
  };
  
const errorCallback = (error) => {
    // console.log(error);
  };


export const getUserPosition = () => {
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(showPosition);
      } else {
        // console.error("Geolocation is not supported by this browser.");
      }
}

function showPosition(position) {
    // console.log(`Latitude: ${position.coords.latitude}, longitude: ${position.coords.longitude}`);
  }





 // sort components that dont use parent ids and dont really have children
// export const sortNoIdComponents = (AllData) =>{
//     var emptycomponent = <></>;
//     let sortComponents = []
//     emptycomponent = AllData.map(eachObject => {
//                 sortComponents.push(eachObject)
//                 sortComponents.sort((a, b) => (a.order > b.order) ? 1 : -1);
//     })
//     return sortComponents
// } 

// @New sorting algo
export const sortNoIdComponents = (AllData) => {
  if (!AllData || !AllData.length) return [];
  
  // Sort once 
  return AllData.slice().sort((a, b) => (a.order > b.order ? 1 : -1));
};



// Actual version
export const  sortParentIdComponents = (dataSearch, AllData) =>{
    
    let sortComponents = [];
    let sortLocations = [];
    // const userLocation = getUserPosition();
    var emptycomponent = AllData.map(function (eachObject) {
         eachObject.parent_ids?.map(function (eachIdofeachComponent) {

            if (eachIdofeachComponent === dataSearch) {
                // console.log(eachObject);
                
                // if(eachObject.action.type === 'locationLink'){
                //     // TODO 1: assign to each the distance compared to the user
                //     // TODO 2: add into array the element
                //     // TODO 3: sort location array with new data
                //     sortLocations.push(eachObject);
                //     sortLocations.sort((a, b) => (a.order > b.order) ? 1 : -1);
                // }else{
                    sortComponents.push(eachObject)
                    sortComponents.sort((a, b) => (a.order > b.order) ? 1 : -1);
                // }
            }
        })
    })

    return sortComponents.concat(sortLocations);
}
